export const version = "ethers/5.4.6";
//# sourceMappingURL=_version.js.map